import React, { useEffect, useState } from "react";
import axios from "axios";
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from "react-image-gallery";
import {
  Box,
  Typography,
  Container,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Button,
  CircularProgress,
} from "@mui/material";

// Constants for YouTube API
const CHANNEL_ID = "UCByVx1cETKCLmYebmKP-ShQ"; // Replace with your YouTube channel ID
const YOUTUBE_API_KEY = "AIzaSyCTvzf_J5VG63c3guT-sanrko2aW5Q8eR8"; // Replace with your YouTube Data API key
const SHARE_KEY = "63xfwDW4UtFLd7tR9";
const SermonsMedia = () => {
  const [videos, setVideos] = useState([]);
  const [images, setImages] = useState(null);
  const [loadingVideos, setLoadingVideos] = useState(true);
  const [loadingImages, setLoadingImages] = useState(true);
  const [errorVideos, setErrorVideos] = useState("");
  const [errorImages, setErrorImages] = useState("");

  // Fetch YouTube videos
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await axios.get(
          `https://www.googleapis.com/youtube/v3/search?key=${YOUTUBE_API_KEY}&channelId=${CHANNEL_ID}&part=snippet&type=video&order=date&maxResults=6`
        );
        setVideos(response.data.items || []);
        setErrorVideos("");
      } catch (err) {
        console.error("Error fetching YouTube videos:", err);
        setErrorVideos("Failed to load videos. Please try again later.");
      } finally {
        setLoadingVideos(false);
      }
    };
    fetchVideos();
  }, []);

  // Fetch Google Photos album using a public API
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await axios.get(
          `https://tnnet.in/api/${SHARE_KEY}` // Replace with your album endpoint
        );
        if (response.data && response.data.length > 0) {
          setImages(
            response.data.map((url) => ({
              original: `${url}=w1024`,
              thumbnail: `${url}=w100`,
            }))
          );
        }
        setErrorImages("");
      } catch (err) {
        console.error("Error fetching album:", err);
        setErrorImages("Failed to load album. Please try again.");
      } finally {
        setLoadingImages(false);
      }
    };
    fetchImages();
  }, []);

  return (
    <Box sx={{ py: 5, backgroundColor: "#f7f3e9" }}>
      <Container>
        {/* Page Title */}
        <Typography variant="h2" gutterBottom align="center" sx={{ fontWeight: "bold", color: "primary.main" }}>
          Sermons & Media
        </Typography>

        {/* YouTube Videos Section */}
        <Box sx={{ mt: 4 }}>
          <Typography variant="h4" align="center" sx={{ color: "primary.main", mb: 3 }}>
            Latest Sermons
          </Typography>
          {loadingVideos ? (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
              <CircularProgress />
            </Box>
          ) : errorVideos ? (
            <Typography variant="body1" color="error" align="center">
              {errorVideos}
            </Typography>
          ) : (
            <Grid container spacing={3}>
              {videos.map((video) => (
                <Grid item xs={12} sm={6} md={4} key={video.id.videoId}>
                  <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
                    <CardMedia
                      component="img"
                      height="200"
                      image={video.snippet.thumbnails.high.url}
                      alt={video.snippet.title}
                    />
                    <CardContent>
                      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                        {video.snippet.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {new Date(video.snippet.publishedAt).toLocaleDateString()}
                      </Typography>
                      <Button
                        href={`https://www.youtube.com/watch?v=${video.id.videoId}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="contained"
                        color="primary"
                        size="small"
                        sx={{ mt: 2 }}
                      >
                        Watch on YouTube
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}
        </Box>

        {/* Media Gallery Section */}
        <Box sx={{ mt: 6 }}>
          <Typography variant="h4" align="center" sx={{ color: "primary.main", mb: 3 }}>
            Media Gallery
          </Typography>

          {loadingImages ? (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
              <CircularProgress />
            </Box>
          ) : errorImages ? (
            <Typography variant="body1" color="error" align="center" sx={{ mb: 4 }}>
              {errorImages}
            </Typography>
          ) : (
            images && <ImageGallery items={images} />
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default SermonsMedia;
